import { AvatarMenu } from "./AvatarMenu";

export function Header() {
    return (
        <header className="slds-global-header_container">
            <div className="slds-global-header slds-grid slds-grid_align-spread">
                <div className="slds-global-header__item"></div>
                <div className="slds-global-header__item">
                    <ul className="slds-global-actions">
                        <li className="slds-global-actions__item">
                            <AvatarMenu />
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    );
}
